import Vue from 'vue'
import Vuex from 'vuex'
import { searchMapPoi } from '@/utils/AMapUtil'
import { reset } from 'echarts/lib/visual/seriesColor'

Vue.use(Vuex)
let _vm = new Vue()

Date.prototype.format = function (str) {
  let fill = num => {
    if ((num + '').length == 2) return num + ''
    else return '0' + num
  }
  let date = this
  str = str || '-'
  let arr = [date.getFullYear(), fill(date.getMonth() + 1), fill(date.getDate())]
  let arr1 = [fill(date.getHours()), fill(date.getMinutes() + 1), fill(date.getMinutes())]
  return arr.join(str) + ' ' + arr1.join(':')
}

export default {
  state: {
    topStat: { cityNum: 0, deviceNum: 0, people: 0 },
    isInitResquest: true, // 是否是第一次初始化请求，多个条件变化都会触发，这里全局控制下首次其他变化不请求
    isOperateReset: false, // 是否是重置操作， 重置按钮点击时触发设置成true，请求完毕还原为false
    searchedPois: [], // 地图POI搜索结果
    searchDetail: [], // 搜索得到的小区列表
    nbhdBasic: [], // 小区基础数据集合（用于触发地图渲染）{ id, check }
    focusPoint: '', // 目标坐标点
    mapZoom: 4.4, // 地图缩放比
    manualDraw: false, // 开启地图绘制模式
    mapZoomData: {
      province: null,
      city: null,
      dist: null
    },
    mapSearchOptions: { // 地图基本搜索条件
      time: [ // 默认后天开始一周的时间范围
        new Date(+ new Date() + 2 * 24 * 3600000).format().slice(0, 10),
        new Date(+ new Date() + 8 * 24 * 3600000).format().slice(0, 10)
      ],
      age: [],
      sex: [],
      income: [],
      distType: [],
      contentTime: '',
      displayRegion: 1
    },
    mapSearchOptionsSenior: { // 地图上方悬浮的高级搜索条件
      areaValue: 9, // 投放范围半径，默认9公里
      city: '',
      keyWord: ''
    },
    advancedFilter: { // 地图投放高级筛选条件
      screenNum: '', // 屏幕数
      recommendData: '', // 推荐度
      mediaTypes: [] // 屏幕类型
    },
    recommendTimeSlotData: [],
    selfChoosePlayTimes: null,
    allTimeRanges: [],
    chooseTimeSlot: { idx: 0, data: [] },
    mapCityList: [], // 下拉切换所有城市
    exportPointData: {}, // 导入搜索结果 { list: [], successCount: 0, totalCount: 0 }
    conditionSearchCitys: [],
    searchPointLabelList: [], // 点位搜索时目标人群相关的下拉列表数据
    labelListMap: {}, // 点位搜索时目标人群相关的下拉列表数据对应map
    labelContextMap: {},
    labelTimeSlotList: [],
    mapImportNbhdSearchList: [],
    mapImportPointSearchList: [], // 导入连锁店搜索
    mapImportPointSearchData: {},
  },
  mutations: {
    // data: { key: state中需要改变值的key名，传数组支持深度赋值(eval处理), value: 赋值的数据 }
    setStoreData(state, data) {
      let key = data.key
      if (Array.isArray(key)) {
        let zhizhen = ''
        while (key.length > 0) {
          zhizhen += "['" + key.shift() + "']"
        }
        eval("state" + zhizhen + '=' + JSON.stringify(data.value))
      } else {
        state[data.key] = data.value
      }
    },
    setTopStat(state, d) {
      state.topStat = d
    },
    setZoomData(state, d) {
      state.mapZoomData = d
    },
    setOptionSenior(state, s) {
      console.log('setOptionSenior', s)
      state.mapSearchOptionsSenior = s
    },
    setAdvancedFilter(state, d) {
      state.advancedFilter = d
    },
    setExportPointData(state, d) {
      state.exportPointData = d
    },
    setImportNbhdList(state, d) {
      state.mapImportNbhdSearchList = d
    },
    setImportPointList(state, d) {
      state.mapImportPointSearchList = d
    },
    setImportPointData(state, d) {
      state.mapImportPointSearchData = d
    },
    setMapCityList(state, d) {
      state.mapCityList = d
    },
    setSearchedPois(state, pois) {
      state.searchedPois = pois
    },
    setFocusPoint(state, data) {
      state.focusPoint = data
    },
    setMapZoom(state, zoom) {
      if (!isNaN(zoom) && zoom > 4 && zoom <= 20) {
        state.mapZoom = zoom
      }
    },
    setReset(state, d) {
      state.isOperateReset = d
    },
    setManualDraw(state, manual) {
      state.manualDraw = manual
    },
    setSearchDetail(state, data) {
      state.searchDetail = data
      if (!data || !data.length) {
        state.nbhdBasic = []
        delete window._nbhds
      }
    },
    // 将用于地图渲染的小区关键数据放入普通数组变量中
    setSearchBasic(state, d) {
      state.nbhdBasic = []
      // 清空数据时需清除window._nbhds
      if (!d || !d.length) {
        delete window._nbhds
      } else if (JSON.stringify(d) !== JSON.stringify(state.nbhdBasic)) {
        const t = setTimeout(() => {
          state.nbhdBasic = d
          clearTimeout(t)
        }, 0)
      }
    },
    setInitRequest(state, d) {
      state.isInitResquest = d
    }
  },
  actions: {
    async poiSearch({ commit }, arg) {
      const res = await searchMapPoi(arg.keyword, arg.option)
      commit('setSearchedPois', res || [])
    },
    async getTimeSlotList({ commit }) {
      let res = await _vm.fetch('/boss/common/config/v2/getContentTime', {}, 'get')
      res && res.data && commit('setStoreData', {
        key: 'labelTimeSlotList', value: res.data || []
      })
    },
    async getTimeRanges({ commit }) {
      let timesAll = await _vm.fetch('/boss/common/config/v2/getFrequencyTree', '', 'get')
      if (timesAll && timesAll.data) {
        commit('setStoreData', {
          key: 'allTimeRanges', value: timesAll.data
        })
      }
    },
    async getSearchPointsLabelList({ commit }) {
      let res = await _vm.fetch('/boss/deviceSlot/v2/getLable')
      if (res && res.code === 0 && res.data && res.data.length > 0) {
        let list = res.data || []
        commit('setStoreData', { key: 'searchPointLabelList', value: list })
        let data = handleLabelMap(list)
        commit('setStoreData', { key: 'labelListMap', value: data.configMap })
        commit('setStoreData', { key: 'labelContextMap', value: data.contextsMap })
      }
    }
  }
}

function handleLabelMap(list) {
  let configMap = {}, contextsMap = {}
  list.forEach(el => {
    el.labelResponses.forEach(ele => {
      configMap[ele.code] = {
        ...ele, type: el.type, group: el.group, typeName: el.typeName,
        list: ele.lableDetailsResponses.map(elem => {
          let item = { ...elem, label: elem.context, labelValue: elem.code + elem.value, codeName: ele.codeName }
          contextsMap[elem.code + elem.value] = item
          return item
        })
      }
    })
  })
  return { configMap, contextsMap }
}
